import {publicAxiosInstance} from "../utils/API";
import api from "../utils/API";


const getSoldeYear = (collaborateurId: string, annee: number) =>
    publicAxiosInstance.get(`/conges/solde/${collaborateurId}/${annee}`);

const updateCongeConsomme = (collaborateurId, { annee, delta, motif }) =>
    api.post(`/conges/consommation`, { collaborateurId, annee, delta, motif });
 const getMovements = (collaborateurId, annee) =>
    api.get(`/conges/mouvements/${collaborateurId}/${annee}`);

export {
    getSoldeYear,
    updateCongeConsomme,
    getMovements
};